<template>
  <div class="mx-auto"
    :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }">
    <div class="w-full">
      <img src="@/assets/images/company/001.jpg" class="object-contain mx-auto">
    </div>
    <div class="w-full">
      <img src="@/assets/images/company/002.png" class="object-contain mx-auto">
    </div>
    <div class="w-full">
      <img src="@/assets/images/company/003.png" class="object-contain mx-auto">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Correction',
  metaInfo () {
    return {
      title: '批改網',
      titleTemplate: null
    }
  }
}
</script>
